import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import { usePressMotion } from '../../lib/press-motion'
import { cn } from '../../lib/utils'

export interface BottomNavActionProps {
  // Pre-rendered icon, e.g. `<Plus size={24} weight="bold" />`. A node so the block stays icon-library
  // agnostic; it renders white on the brand-green fill.
  icon: ReactNode
  // Accessible name for the icon-only button (e.g. "New meal plan", "Accept & start plan").
  label: string
  onClick?: () => void
  // Set to -1 to take the button out of the tab order while it's hidden/collapsing.
  tabIndex?: number
  className?: string
}

// The bottom nav's circular action button (FAB): a 48px brand-green, icon-only button with the beUI
// spring-squish on press (which replaces a translate press) and a color darken on hover.
export function BottomNavAction({ icon, label, onClick, tabIndex, className }: BottomNavActionProps) {
  const press = usePressMotion()
  return (
    <motion.button
      type="button"
      {...press}
      onClick={onClick}
      aria-label={label}
      tabIndex={tabIndex}
      className={cn(
        'flex size-12 shrink-0 items-center justify-center rounded-full bg-brand-green text-white shadow-[0_1px_4px_rgb(30_51_25_/_0.35)] transition-colors hover:bg-brand-green-600',
        className
      )}>
      {icon}
    </motion.button>
  )
}
